import {
    Box,
    Button,
    Card,
    IconButton,
    Stack,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material'
import { FC } from 'react'
import BackIcon from '../../assets/icons/ArrowLeft.svg'
import UploadIcon from '../../assets/icons/Upload.svg'
import { APP_TOP_INDENT, APP_TOP_INDENT_MOBILE } from '../../constants/app.indents'
import { DocumentMarkdown } from './components/DocumentMarkdown'

type Props = {
    title: string
    document: string
    onBack?: VoidFunction
    onDownload?: VoidFunction
}

export const DocumentWrapper: FC<Props> = ({ title, onBack, onDownload, document }) => {
    const { breakpoints } = useTheme()

    const isMobile = useMediaQuery(breakpoints.down('md'))

    return (
        <Card
            sx={{
                height: '100%',
                maxHeight: `calc(100dvh - ${isMobile ? APP_TOP_INDENT_MOBILE : APP_TOP_INDENT}px)`,
                p: 0,
            }}>
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                    p: 2,
                    pl: isMobile ? 2 : 3,
                    borderBottom: '1px solid #F4F4F6',
                }}>
                <Stack direction="row" alignItems="center" gap={2}>
                    {onBack && (
                        <IconButton
                            size="large"
                            onClick={onBack}
                            sx={{
                                backgroundColor: '#F9FAFB',
                            }}>
                            <BackIcon />
                        </IconButton>
                    )}
                    <Typography variant={isMobile ? 'h6' : 'h4'}>{title}</Typography>
                </Stack>
                {onDownload &&
                    (isMobile ? (
                        <IconButton
                            sx={{
                                border: '1px solid #E9EAED',
                            }}
                            size="medium"
                            onClick={onDownload}>
                            <UploadIcon />
                        </IconButton>
                    ) : (
                        <Button
                            startIcon={<UploadIcon />}
                            variant="outlined"
                            sx={{
                                width: '118px',
                                gap: 0,
                            }}
                            onClick={onDownload}>
                            Скачать
                        </Button>
                    ))}
            </Stack>
            <Box
                sx={{
                    display: 'block',
                    p: isMobile ? '40px 16px' : '40px 112px 40px 32px',
                    height: isMobile ? 'calc(100dvh - 145px)' : 'calc(100% - 80px)',
                    overflowY: 'auto',
                }}>
                <DocumentMarkdown content={document} />
            </Box>
        </Card>
    )
}
